<script>
import { Tooltip } from 'ant-design-vue';

export default {
  components: { Tooltip },
  props: {
    title: {
      type: String,
      required: true,
    },
    placement: {
      type: String,
      default: 'top',
    },
    color: {
      type: String,
      default: 'rgb(245, 150, 0)',
    },
    overlayInnerStyle: {
      type: Object,
      default: () => ({ fontSize: '0.85rem', color: ' rgb(0, 0, 0)' }),
    },
  },
};
</script>

<template>
  <div>
    <Tooltip
      :title="title"
      :placement="placement"
      :arrowPointAtCenter="true"
      :color="color"
      :overlayInnerStyle="overlayInnerStyle"
    >
      <slot> </slot>
    </Tooltip>
  </div>
</template>

<style lang="scss" scoped></style>
